const Gray = {
  level0: '#FFFFFF',
  level1: '#EEEEEE',
  S300: '#EEEEEE',
  level2: '#E3E3E3',
  S400: '#E3E3E3',
  level3: '#D1D1D1',
  S500: '#D1D1D1',
  level4: '#ACACAC',
  S600: '#ACACAC',
  level5: '#8B8B8B',
  S700: '#8B8B8B',
  level6: '#646464',
  S800: '#646464',
  level7: '#333333',
  S900: '#333333',
  level8: '#000000',
};

export { Gray };
